import React from 'react';
import styled, { css } from 'styled-components/macro';
import { Image } from '@yme/atoms/image';
import { SVGIcon } from '@yme/atoms/svg-icon';
import { Link } from '@yme/components/Link';
import { colorBrandYamahaRed, colorCoreBlack100, colorCoreBlack900Base, colorCoreGray100, } from '@yme/tokens/colors';
import { CORNER_RADIUS } from '@yme/tokens/cornerRadius';
import { elevationBottomLvl1, elevationBottomLvl2 } from '@yme/tokens/elevations';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { ADAPTIVE } from '@yme/tokens/screen';
import { INDENT } from '@yme/tokens/sizes';
import { Z_INDEX } from '@yme/tokens/zindex';
import { AspectRatio } from '@yme/utils/constants';
import { ellipsisEndingLine, getTextStyles } from '@yme/utils/styles';
const rowPaddings = css `
  ${({ isRightToLeft }) => (isRightToLeft ? `0 0 0 ${INDENT.xs}` : `0 ${INDENT.xs} 0 0`)};
`;
const rowCardStyles = css `
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  height: 68px;
  padding: ${({ isFullWidth }) => (isFullWidth ? rowPaddings : INDENT.xs)};
`;
export const YAMTIconStyled = styled(SVGIcon) `
  width: 55px;

  svg {
    width: 100%;
  }
`;
const columnCardStyles = css `
  flex-direction: column;
  align-items: center;
  height: 128px;
  padding: ${({ isFullWidth }) => (isFullWidth ? `0 0 ${INDENT.xs}` : INDENT.xs)};
`;
const columnImageStyles = css `
  margin-bottom: ${INDENT.xs};

  ${({ isFullWidth }) => isFullWidth
    ? css `
          max-width: initial;
          height: 80px;
        `
    : css `
          max-width: 93px;
        `};
`;
const rowImageStyles = css `
  margin-bottom: 0;

  ${({ isFullWidth }) => isFullWidth
    ? css `
          max-width: 80px;
          height: 100%;
        `
    : css `
          max-width: 64px;
        `};
`;
export const UnitCardTitle = styled.p `
  ${getTextStyles('Ubuntu', 500, 14, 20)}
  color: ${colorCoreBlack900Base};
  max-width: 100%;
  margin: 0;
  padding: 0 ${INDENT.xxxs};
  box-sizing: border-box;
  text-align: center;

  ${ellipsisEndingLine}

  ${ADAPTIVE.maxWidth.desktop} {
    ${({ isRightToLeft }) => isRightToLeft ? `padding-right: ${INDENT.xxxs}` : `padding-left: ${INDENT.xxxs}`};
  }

  ${ADAPTIVE.maxWidth.tablet} {
    padding: 0 ${INDENT.xxxs};
  }

  ${ADAPTIVE.maxWidth.mobile} {
    ${({ isRightToLeft }) => isRightToLeft ? `padding-right: ${INDENT.xxxs}` : `padding-left: ${INDENT.xxxs}`};
  }
`;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const UnitCardStyled = styled(({ isFullWidth, isTouchDevice, isRightToLeft, ...rest }) => (React.createElement(Link, { ...rest }))) `
  position: relative;
  display: flex;
  box-sizing: border-box;
  background: ${colorCoreGray100};
  border-radius: ${CORNER_RADIUS.xs};
  box-shadow: ${elevationBottomLvl1};
  color: ${colorCoreBlack900Base};
  text-decoration: none;
  overflow: hidden;

  direction: ${({ isRightToLeft }) => (isRightToLeft ? 'rtl' : 'ltr')};

  ${columnCardStyles};

  @media (hover: hover) {
    &:hover {
      box-shadow: ${elevationBottomLvl2};

      ${UnitCardTitle} {
        color: ${colorBrandYamahaRed};
      }
    }
  }

  &:active {
    box-shadow: 0 0 0 1px ${colorCoreBlack100};

    ${UnitCardTitle} {
      color: ${colorBrandYamahaRed};
    }
  }

  ${ADAPTIVE.maxWidth.desktop} {
    ${({ isTouchDevice }) => (isTouchDevice ? columnCardStyles : rowCardStyles)};
  }

  ${ADAPTIVE.maxWidth.tablet} {
    ${columnCardStyles};
  }

  ${ADAPTIVE.maxWidth.mobile} {
    ${rowCardStyles};
  }
`;
export const UnitCardPreview = styled.div `
  width: 100%;

  ${columnImageStyles};

  ${ADAPTIVE.maxWidth.desktop} {
    ${({ isTouchDevice }) => (isTouchDevice ? columnImageStyles : rowImageStyles)};
  }

  ${ADAPTIVE.maxWidth.tablet} {
    ${columnImageStyles};
  }

  ${ADAPTIVE.maxWidth.mobile} {
    ${rowImageStyles};
  }
`;
export const ImageStyled = styled(Image) `
  img {
    height: 100%;
    object-fit: ${({ isFullWidth }) => (isFullWidth ? 'cover' : 'contain')};
    aspect-ratio: ${AspectRatio.RectangleLevel3};
  }
`;
const menuIconStyles = css `
  position: absolute;
  top: ${INDENT.xxxxs};
  ${({ isRightToLeft }) => (isRightToLeft ? `right: ${INDENT.xxxxs}` : `left: ${INDENT.xxxxs}`)};
  z-index: ${Z_INDEX.level1};
`;
export const IconsWrapperStyled = styled(FlexWrapper) `
  position: absolute;
  top: ${INDENT.xxxxs};
  z-index: ${Z_INDEX.level1};

  width: ${({ isImageFullWidth }) => (isImageFullWidth ? '100%' : 'calc(100% - 32px)')};
`;
export const ElectricVehicleStyled = styled.span `
  ${menuIconStyles}
`;
